module.exports = __webpack_public_path__ + "static/media/Bell.fb722d3d.svg";